/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { IS_REGION_AU, IS_REGION_AU_OR_NZ, IS_REGION_NZ, IS_REGION_US } from '@gh/common-shared';
import { assign } from 'lodash';
import { ContactDetailsCreditorSubContractorFormState } from './contact-details-creditor-sub-contractor-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-creditor-sub-contractor',
  templateUrl: 'contact-details-creditor-sub-contractor-tab.component.html',
})
export class ContactDetailsCreditorSubContractorTabComponent implements OnInit {

  constructor(private route: ContextRoute,
              public form: ContactDetailsCreditorSubContractorFormState) {

  }

  get usRegion(): boolean {
    return IS_REGION_US;
  }

  get auRegion(): boolean {
    return IS_REGION_AU;
  }

  get nzRegion(): boolean {
    return IS_REGION_NZ;
  }

  get auOrNzRegion(): boolean {
    return IS_REGION_AU_OR_NZ;
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }
}
